var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},_vm._l((_vm.incomeList),function(income){return _c('div',{key:income.id,on:{"click":function($event){return _vm.toOrderDetail(income)}}},[_c('order-item',{attrs:{"id":income.order_no,"time":income.created_at,"price":'+' + income.agent_amount + '元'}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed0a9414","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/incomeparticularsdetail/Incomeparticularsdetail.vue
// module id = null
// module chunks = 